var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { PLATFORM_DATETIME_FORMAT } from "./constants";
import fecha from 'fecha';
import { formatDate } from "./format-date";
export var getItemsSoonestDate = function (items, toFormat, fromFormat) {
  if (toFormat === void 0) {
    toFormat = 'DD MMM YYYY';
  }
  if (fromFormat === void 0) {
    fromFormat = PLATFORM_DATETIME_FORMAT;
  }
  if (!items || items.length === 0) return null;
  var soonestTimestamp = Math.min.apply(Math, __spreadArray([], __read(items.map(function (item) {
    var _a;
    return item.startDate ? (_a = fecha.parse(item.startDate, fromFormat)) === null || _a === void 0 ? void 0 : _a.getTime() : NaN;
  }) // Parse dates
  .filter(function (timestamp) {
    return !isNaN(timestamp);
  }) // Remove invalid dates
  ), false));
  return isFinite(soonestTimestamp) ? formatDate(new Date(soonestTimestamp), toFormat) : null;
};